import { gql } from '@apollo/client';

export default gql`
  mutation refundBookingFees($bookingReference: String!, $overrideReason: String!, $itemRefs: [String]!) {
    cancelSpecificBookingItems(
      bookingReference: $bookingReference
      overrideAftersalesRules: true
      overrideReason: $overrideReason
      itemRefs: $itemRefs
    ) {
      reference
    }
  }
`;
